import { Typography } from '@mui/material';
import React from 'react';
import { colors } from '../index';

export default function SectionTitle({ children, subtitle = '' }) {
  return (
    <>
      <Typography
        sx={{
          fontSize: 20,
          fontWeight: 'bold',
          textTransform: 'uppercase',
          mb: 2,
          color: colors.primary,
        }}
      >
        {children}
      </Typography>
      {!!subtitle && (
        <Typography variant="body1" sx={{ mb: 2, color: colors.text }}>
          {subtitle}
        </Typography>
      )}
    </>
  );
}
